export default __webpack_public_path__ + "static/logo-12-86b109976bafb5815238cd19e4e2941c.jpeg";